import { http, createConfig } from 'wagmi'
import { mainnet, sepolia,bscTestnet, bsc } from 'wagmi/chains'

export const config = createConfig({
  chains: [bsc],
  transports: {
   
    [bsc.id]: http("https://bsc-dataseed.binance.org/"),
  },
})



// import { http, createConfig } from 'wagmi'
// import { mainnet, sepolia,bscTestnet, bsc } from 'wagmi/chains'

// export const config = createConfig({
//   chains: [mainnet, sepolia],
//   transports: {
//     // [mainnet.id]: http(),
//     // [sepolia.id]: http(),
//     [bsc.id]: http(),
//   },
// })